import axios from 'axios';
import eventHelper from '../../mixins/eventHelper';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      introduction: {},
      enfs: {},
      __updatedAt: {},
    },
    mutations: {
      SET_INTRODUCTION(state, { data, locale }) {
        state.introduction = {
          ...state.introduction,
          [locale]: data,
        }
        state.__updatedAt[locale] = Date.now();
      },
      SET_ENF(state, { data, locale}) {
        state.enfs = {
          ...state.enfs,
          [locale]: data,
        }
        state.__updatedAt[locale] = Date.now();
      },
    },
    actions: {
      FETCH_EVENT_CALENDAR({ state, commit }, { locale }) {
        if (state.introduction[locale]
          && state.enfs[locale]
          && state.__updatedAt[locale]
          && Date.now() - state.__updatedAt[locale] < cachetime 
        ) return ;

        return axios.get(encodeURI(`/api/enf/calendar`))
          .then((res) => {
            const data = res.data || {};
            const { Introduction="", introduction="", enfs=[] } = data;

            commit('SET_INTRODUCTION', { data: introduction || Introduction, locale });
            commit('SET_ENF', { 
              data: eventHelper.methods.sortCalendarEvent(enfs), 
              locale 
            });
          }).catch(err => console.log(err));      
      },
    },
    getters: { 
      getIntroduction: (state) => (locale) => {
        return state.introduction[locale] || '';
      },
      getEnfs: (state) => (locale) => {
        return state.enfs[locale] || [];
      }
    }
  }
}